import React from 'react'
import Router from 'next/router'
import { connect } from 'react-redux'
import RequestPasswordResetForm from 'components/public/auth/RequestPasswordResetForm'
import { requestPasswordReset } from 'redux/actions/authentication'
import { isAuthenticated } from 'utils/auth'
import AuthLayout from 'layouts/auth-layout'

interface RequestPasswordResetProps {
	dispatch: any
	authenticated: boolean
}

export const getServerSideProps = (ctx) => {
	return {
		props: {
			authenticated: isAuthenticated(ctx),
		},
	}
}

// Port in to using useState hooks, if you need state
class RequestPasswordReset extends React.Component<
	RequestPasswordResetProps,
	{ loading: boolean; error: string; submitted: boolean }
> {
	constructor(props: any) {
		super(props)

		this.handleRequestPasswordResetSubmit =
			this.handleRequestPasswordResetSubmit.bind(this)
		this.state = {
			loading: false,
			submitted: false,
			error: '',
		}
	}

	componentDidMount() {
		if (this.props.authenticated) {
			Router.push('/')
		}
	}

	handleRequestPasswordResetSubmit(formData: any) {
		this.setState({ loading: true })
		this.props
			.dispatch(requestPasswordReset(formData))
			.then(() => this.setState({ submitted: true }))
			.catch((error) => {
				console.log(error)
				this.setState({ error: error.message ? error.message : error })
			})
	}

	render() {
		return (
			<AuthLayout title="Recover password">
				{!this.state.submitted && (
					<RequestPasswordResetForm
						onFormSubmit={this.handleRequestPasswordResetSubmit}
						error={this.state.error}
					/>
				)}

				{this.state.submitted && (
					<p className="px-8 pt-6 pb-8 mb-4 text-center">
						Check your email for a link to reset your password
					</p>
				)}
			</AuthLayout>
		)
	}
}

export default connect()(RequestPasswordReset)
